import { CountryList } from "../admin/components/Constants";
import { authData } from "../admin/components/GetAuth";
import { CacheGetItem, STORAGE_KEYS } from "../admin/components/StorageComp";

// Each company picks its own collection (pickup) and destination (delivery) country, so labels
// such as "{delivery country} Delivery" are built from the company settings instead of being written in.

const EXTRA_NAMES = { GB: "UK" };

export const countryName = (code) => {
  if (!code) return "";
  const upper = String(code).toUpperCase();
  return EXTRA_NAMES[upper] || CountryList.find((c) => c.value === upper)?.label || upper;
};

// Country picker options: United Kingdom first (CountryList doesn't include it), then every other country
export const COUNTRY_OPTIONS = [{ value: "GB", label: "United Kingdom" }, ...CountryList.filter((c) => c.value !== "GB")];

// websiteData (public tenant site), else the signed-in user's company, else the cached tenant website config
export const companyCountries = (websiteData) => {
  const company = authData()?.company;
  const site = websiteData || CacheGetItem(STORAGE_KEYS.WEBSITE);
  const pickupCode = (site?.pickup_country || company?.pickup_country || "GB").toUpperCase();
  const deliveryCode = (site?.delivery_country || company?.delivery_country || "GH").toUpperCase();
  return {
    pickupCode,
    deliveryCode,
    pickup: countryName(pickupCode),
    delivery: countryName(deliveryCode),
  };
};
